import React, { useEffect, useReducer, useState } from 'react'
import CustomAddPage from '../../components/CustomComponents/CustomAddPage'
import { usePermissions } from '../../hooks/SuperAdmin/usePermissions'
import { useQuery, useQueryClient } from 'react-query'
import { createDocument } from '../../lib/RestApi/customApiHandler'
import {useParams} from 'react-router';

export default function AddSuperPermissions() {
  const [modules, setModules] = useState({
    EMPLOYEE: {
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      UPLOAD: false,
      FLAG: false,
    },
    LEAD: {
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      UPLOAD: false,
      FLAG: false,
    },
    SALES: {
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      UPLOAD: false,
      FLAG: false,
    },
    PRODUCT: {
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      UPLOAD: false,
      FLAG: false,
    },
    LEARNING: {
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      UPLOAD: false,
      FLAG: false,
    },
    AUDIT: {
      CREATE: true,
      READ: false,
      UPDATE: false,
      DELETE: false,
      UPLOAD: false,
      FLAG: false,
    },
  })
  // const [permission, setPermission] = useState({});
  const [tempModule, setTempModule] = useState({})
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0)
  const params = useParams();

  function handleClickNew() {
    forceUpdate()
  }

  const [form, setForm] = useState({
    name: '',
    code: '',
    active: true,
  })
  //console.log('tempModule : ', tempModule)
  const { addPermissions, loading, updatePermissions, getPermission, permission, setPermission } = usePermissions()

  const handleSubmit = () => {
    let allowed = [];
    Object.keys(tempModule).map((item, i)=>{
      allowed.push({ module: item, subPermission: tempModule[item]})
    })
    if (params.id !== undefined ) {
      updatePermissions({ ...form, allowed: allowed, _id : params.id })
    } else {
      addPermissions({ ...form, allowed: allowed })
    }
  }
  const inputFields = [
    { label: 'Permission Code', value: form.code, name: 'code' },
    { label: 'Name', value: form.name, name: 'name' },
    { label: 'Status', value: form.active, type: 'ACTIVE' },
  ]

  useEffect(() => {
    if (params.id !== undefined ) {
      getPermission(params.id)
    }
  }, [params])

  useEffect(()=>{
    if(permission){
      console.log(permission)
      console.log(permission, 'sparsh')
      let crudOperation = permission.allowed
      let crud = {}
      crudOperation.forEach((element) => {
        crud[element.module] = element.subPermission
      })
      console.log(crud)
      setTempModule(crud)
      setForm({ ...crud, code: permission.code, name: permission.name})
    }
  }, [permission])

  return (
    <CustomAddPage
      heading="Permission"
      redirect="PERMISSIONS"
      currentData={permission}
      editUrl={'EDIT_SUPER_ADMIN_PERMISSIONS'}
      loading={loading}
      state={form}
      setState={setForm}
      handleClick={handleSubmit}
      inputFields={inputFields}
      modules={modules}
      setModules={setModules}
      tempModule={tempModule}
      setTempModule={(obj) => {
        setTempModule(obj)
        handleClickNew()
      }}
    />
  )
}
